var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lio-progress"},[_c('div',{staticClass:"text-center mb-2"},[_vm._t("default")],2),_c('div',{staticClass:"progress-anim",style:({animation: "colorAnimation linear 1.5s infinite"})})])}
var staticRenderFns = []

export { render, staticRenderFns }